import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useObserver } from "mobx-react-lite";
import { useStores } from "../../../store";
import { DownloadResume } from "../resume_output";

const Resume17 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div
        className="max-w-4xl mx-auto my-10 bg-white border-8 border-yellow"
        ref={resumeRef}
      >
        <div className="flex">
          <div className="w-1/3 bg-gray-100 p-5 text-center">
            <div className="mb-5">
              <img
                className="w-30 h-30 rounded-full object-cover mx-auto"
                src={
                  ResumeStore?.resumeBuilder?.profile ||
                  "https://via.placeholder.com/120"
                }
                alt="Profile"
              />
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                Contact
              </h2>
              <p>
                {ResumeStore?.resumeBuilder.personalDetails.firstName}{" "}
                {ResumeStore?.resumeBuilder.personalDetails.lastName}
              </p>
              <p>{ResumeStore?.resumeBuilder.personalDetails.address}</p>
              <p>{ResumeStore?.resumeBuilder.personalDetails.phone}</p>
              <p>{ResumeStore?.resumeBuilder.personalDetails.email}</p>
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                Skills
              </h2>
              <ul className="list-none p-0">
                {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                  <li key={index} className="text-gray-700">
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                Languages
              </h2>
              {ResumeStore?.resumeBuilder.languages.map((lang, index) => (
                <p key={index} className="text-gray-700">
                  {lang.language} ({lang.level})
                </p>
              ))}
            </div>
          </div>
          <div className="w-2/3 p-5">
            <header className="mb-6">
              <h1 className="text-3xl font-bold text-gray-800">
                {ResumeStore?.resumeBuilder.personalDetails.firstName}{" "}
                {ResumeStore?.resumeBuilder.personalDetails.lastName}
              </h1>
              <h2 className="text-xl font-medium text-gray-600">
                {ResumeStore?.resumeBuilder.personalDetails.jobTitle}
              </h2>
            </header>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                Professional Summary
              </h2>
              <p className="text-gray-700">
                {ResumeStore?.resumeBuilder.profileSummary}
              </p>
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                Education
              </h2>
              {ResumeStore?.resumeBuilder.education.map((edu, index) => (
                <>
                  <h3 className="text-lg font-medium text-gray-800">
                    {edu.degree}
                  </h3>
                  <p key={index} className="text-gray-700">
                    {edu.school}, {edu.startDate} - {edu.endDate}
                  </p>
                </>
              ))}
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                Work History
              </h2>
              {ResumeStore?.resumeBuilder.employementHistory.map(
                (job, index) => (
                  <div key={index} className="mb-4">
                    <h3 className="text-lg font-medium text-gray-800">
                      {job.jobTitle}
                    </h3>
                    <p className="text-gray-600">
                      {job.company}, {job.city} | {job.startDate} -{" "}
                      {job.endDate}
                    </p>
                    <ul className="list-disc pl-5 text-gray-700">
                      {job.description?.split("\n").map((desc, idx) => (
                        <li key={idx}>{desc}</li>
                      ))}
                    </ul>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  ));
};

export default Resume17;
